var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('v-skeleton-loader',{attrs:{"elevation":"2","type":"article, divider, list-item-avatar, list-item-avatar, list-item-avatar"}}):_c('v-card',{attrs:{"outlined":_vm.outlined}},[_c('report-details-card-content',{attrs:{"report":_vm.report}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }